// extracted by mini-css-extract-plugin
export var defaultFont = "index-module--default-font--EaUXv";
export var fontWeight500 = "index-module--font-weight-500--J+obV";
export var codeFont = "index-module--code-font--wuUyV";
export var textGreen = "index-module--text-green--diy+b";
export var clearButtonStyles = "index-module--clear-button-styles--fjWso";
export var card = "index-module--card--yyk74";